import { Pipe, PipeTransform } from '@angular/core';
import { StatusTextType } from '../constants/status-text.type';
import { StatusType } from '../constants/status.type';

@Pipe({
  name: 'hearingBadgeStatus',
  pure: true,
})
export class HearingBadgeStatusPipe implements PipeTransform {
  constructor() {}

  public StatusType: StatusType;

  transform(value: string, hearingDate: Date): string {
    if (value == StatusType.Rejected) {
      return StatusTextType.Rejected;
    } else if (value == StatusType.AdjournmentRejected) {
      return StatusTextType.AdjournmentRejected;
    } else if (value == StatusType.Submitted) {
      return StatusTextType.Pending;
    } else if (value == StatusType.Approved) {
      const now = new Date();
      if (hearingDate < now) {
        return StatusTextType.DatePassed;
      } else {
        return StatusTextType.Upcoming;
      }
    } else if (value == StatusType.Adjourned) {
      return StatusTextType.Adjourned;
    } else if (value == StatusType.AdjouredSineDie) {
      return StatusTextType.AdjouredSineDie;
    } else if (value == StatusType.Submitted) {
      return StatusTextType.Pending;
    } else if (value == StatusType.AdjournmentPending) {
      return StatusTextType.AdjournmentPending;
    } else if (value == StatusType.AdjournmentSineDiePending) {
      return StatusTextType.AdjournmentSineDiePending;
    } else if (value == StatusType.Cancelled) {
      return StatusTextType.Cancelled;
    } else {
      console.error('HearingBadgeStatusPipe: no matching status found');
      return '';
    }
  }
}
